async function request(path,method,body,token) {
  const controller=new AbortController(),timer=setTimeout(()=>controller.abort(),25000);
  try {
    const response=await fetch("/roster-api"+path,{method,headers:{"Content-Type":"application/json",...(token ? {Authorization:"Bearer "+token} : {})},...(body ? {body:JSON.stringify(body)} : {}),signal:controller.signal,cache:"no-store"});
    const data=await response.json().catch(()=>({error:"The roster form is unavailable right now. Please try again or contact your photographer."}));
    if(!response.ok || data.error)throw new Error(data.error || "The roster could not be saved. Please try again.");
    return data;
  }catch(error){if(error.name==="AbortError")throw new Error("The request timed out. Retry to check whether your roster was received.");if(error instanceof TypeError)throw new Error("Could not connect. Check your connection and try again.");throw error;}
  finally{clearTimeout(timer);}
}
export const getPublicRoster=token=>request("/public/info","POST",{token});
export const submitPublicRoster=(token,requestId,players)=>request("/public/submit","POST",{token,requestId,players});
export async function staffRosterRequest(user,path,method="GET",body) {
  if(!user?.getIdToken)throw new Error("Sign in again to manage client roster links.");
  return request("/staff"+path,method,body,await user.getIdToken());
}
